import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { DataContext } from 'providers/data';
import { ParamsPageWebView } from 'utils/typeServices';

import ParseWebView from 'components/views/ParseWebView';
import ServicePackages from 'components/views/ServicePackages';
import IndividualServices from 'components/views/IndividualServices';
import PageErrorPendingTicket from 'components/views/ExchangeCenter/PageErrorPendingTicket';

const AdditionalServices = ({ isWebView }: ParamsPageWebView) => {
    const { state } = useLocation();
    const { customerCars, selectedCar, dataGetListarCotacoes, dataErrorTicketOpen, handleErrorTicketOpen, handlePostChooseQuoteItems, handleParseProductCart, handleSelectedCar, handleGetCustomerCharges } = useContext(DataContext);

    const handleParseProductCartState = () => {
        if (dataGetListarCotacoes?.quoteItemsChooses && selectedCar) {
            handleParseProductCart({
                body: {
                    cD_COTACAO: dataGetListarCotacoes.quote.cD_COTACAO,
                    cD_PEDIDO: state.cD_PEDIDO,
                    customerId: selectedCar.CD_PESSOA,
                    quoteItemsChooses: dataGetListarCotacoes?.quoteItemsChooses
                }
            });
        }
    }

    useEffect(() => {
        if (state?.isExchangesInProgress) {
            handleParseProductCartState();

            const carSelected = customerCars.find(({ CD_PEDIDO }) => CD_PEDIDO === state.cD_PEDIDO);

            if (carSelected) {
                handleSelectedCar(carSelected);

                handleGetCustomerCharges({
                    token: localStorage.getItem('token')!,
                    nrPlatform: carSelected.NR_PLATAFORMA
                });
            }
        } else {
            handlePostChooseQuoteItems();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    return (
        <ParseWebView stepActive={1} isWebView={isWebView} typePage='quotation' showShoppingCart={true}>           
            {
                dataErrorTicketOpen ? (
                    <PageErrorPendingTicket isWebView={isWebView} handleErrorTicketOpen={handleErrorTicketOpen} />
                ) : (
                    <>
                        <IndividualServices />
                        <ServicePackages />
                    </>
                )
            }
        </ParseWebView>
    );
}

export default AdditionalServices;